/* eslint-disable */

/** How to deposit funds to a customer. */
export enum DepositMechanism {
  /** CREDIT - Use the credit networks to send an unlinked refund. */
  CREDIT = "CREDIT",
  /** DEBIT - Use the debit networks to deposit funds to a debit card. */
  DEBIT = "DEBIT",
  /** ACH - Use ACH to deposit funds to a bank account. */
  ACH = "ACH",
}
